import {
    TOGGLE_LOADING_INDICATOR, SET_MESSAGE_RESPONSE, MessageResponse,SystemState,SystemActionTypes
} from "./types";

export const initialState: SystemState = {
    showLoading: false,
    messageResponse: null    
};

export function systemReducer(
    state = initialState,
    action: SystemActionTypes
): SystemState {
    switch (action.type) {
        case TOGGLE_LOADING_INDICATOR:
            return {
                ...state,
                showLoading: action.payload as boolean
            };
        case SET_MESSAGE_RESPONSE:
            return {
                ...state,
                messageResponse: action.payload as MessageResponse
            };
        default:
            return state;
    }
}
